import { render, staticRenderFns } from "./AssetPreviewMini.vue?vue&type=template&id=68c3925c&lang=pug&"
import script from "./AssetPreviewMini.vue?vue&type=script&lang=js&"
export * from "./AssetPreviewMini.vue?vue&type=script&lang=js&"
import style0 from "./AssetPreviewMini.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports